import {
  CRATE_EXERCISE,
  DEPARTURE_EXERCISE,
  DIAB_EXERCISE,
  MAT_EXERCISE
} from "./exerciseTypes";

const NAV_ROUTES = {
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot_password",
  NEW_PASSWORD: "/new_password",
  REGISTER: {
    DETAILS: "/register/details",
    COMPLETE: "/register/complete",
    START: "/register",
  },
  PURCHASE: "/purchase",
  PURCHASE_SA_PRO: "/purchase-sa-pro",
  PURCHASE_SA_PRO_COMPLETE: "/purchase-sa-pro-complete",
  BECOME_A_HERO: "/become-a-hero",
  HOME: "/",
  OWNER: {
    HOME: "/app",
    DASHBOARD: "/app/dashboard",
    DASHBOARD_ASSISTANT: "/app/dashboard/assistant",
    CHAT: "/app/chat",
    TRAINING: "/app/training",
    TRAINING_END: "/app/training/end",
    TRAINING_EXERCISE: "/app/training/exercise",
    TRAINING_SETUP: "/app/training/setup",
    TRAINING_CATEGORY: "/app/training/category",
    TRAINING_CATEGORY_SPECIALIST: "/app/training/category-specialist",
    TRAINING_DIAB_SETUP: "/app/training/diab-setup",
    TRAINING_DIAB_EXERCISE: "/app/training/diab-exercise",
    TRAINING_DIAB_END: "/app/training/diab-end",
    TRAINING_CRATE_SETUP: "/app/training/crate-setup",
    TRAINING_CRATE_EXERCISE: "/app/training/crate-exercise",
    TRAINING_CRATE_END: "/app/training/crate-end",
    TRAINING_MAT_SETUP: "/app/training/mat-setup",
    TRAINING_MAT_EXERCISE: "/app/training/mat-exercise",
    TRAINING_MAT_END: "/app/training/mat-end",
    HISTORY: "/app/history",
    HISTORY_EDIT: "/app/history/edit",
    HISTORY_DIAB_EDIT: "/app/history/diab-edit",
    HISTORY_CRATE_EDIT: "/app/history/crate-edit",
    HISTORY_MAT_EDIT: "/app/history/mat-edit",
    SETTINGS: "/app/settings",
    DOGS: "/app/settings/dogs",
    DOGS_EDIT: "/app/settings/dogs/edit/",
    PROFILE: "/app/settings/profile",
    FAMILY: "/app/settings/family",
    SCENARIOS: "/app/settings/scenarios",
    ACHIEVEMENTS: "/app/activity/achievements",
    HEROBOARDS: "/app/activity/heroboards",
    GOALS: "/app/activity/goals",
    FRIENDS: "/app/activity/friends",
    FEED: "/app/activity/feed",
    SOCIAL_OPT_IN: "/app/activity/optin",
    ACTIVITY: "/app/activity",
    HOWTO: "/app/howto",
    SUBSCRIPTION: "/app/subscription",
    RENEW: "/app/renew",
  },
  COACH: {
    DASHBOARD: "/trainer",
    DASHBOARD_EXPLICIT: "/trainer/dashboard",
    MAX_CLIENT_LIMIT: "/trainer/max-client-limit",
    CHAT: "/trainer/chat",
    CHAT_VIEW: "/trainer/chat/view/",
    CLIENT: "/trainer/client/:family_id",
    SCENARIOS: "/trainer/client/:family_id/scenarios",
    HISTORY: "/trainer/client/:family_id/history",
    HISTORY_VIEW: "/trainer/client/:family_id/history/view/:exercise_id",
    HISTORY_DIAB: "/trainer/client/:family_id/history/diab/:exercise_id",
    HISTORY_CRATE: "/trainer/client/:family_id/history/crate/:exercise_id",
    HISTORY_MAT: "/trainer/client/:family_id/history/mat/:exercise_id",
    PENDING_CLIENT: "/trainer/pending-client/:family_id",
    ADD_CLIENT: "/trainer/add-client",
    SETTINGS: "/trainer/settings",
    PROFILE: "/trainer/settings/profile",
    LICENSES: "/trainer/licenses",
    RENEW_TRIAL: "/trainer/renew",
    PLANS: "/trainer/plans",
    CREATE_PLAN: "/trainer/plans/:family_id/create",
    EDIT_PLAN: "/trainer/plans/:family_id/edit",
    VIEW_PLAN: "/trainer/plans/:family_id/view",
    CREATE_PLAN_DIAB: "/trainer/plans/:family_id/create-diab",
    VIEW_PLAN_DIAB: "/trainer/plans/:family_id/view-diab",
  },
  ADMIN: {
    DASHBOARD: "/admin-ui",
  },
};

export const TRAINING_KEYS = {
  diab: "diab",
  desensitization: "desensitization",
  crate: "crate",
  mat: "mat",
};

export const getExerciseRouteForType = (type) => {
  switch (type) {
    case DEPARTURE_EXERCISE:
      return NAV_ROUTES.OWNER.TRAINING_EXERCISE;
    case DIAB_EXERCISE:
      return NAV_ROUTES.OWNER.TRAINING_DIAB_EXERCISE;
    case CRATE_EXERCISE:
      return NAV_ROUTES.OWNER.TRAINING_CRATE_EXERCISE;
    case MAT_EXERCISE:
      return NAV_ROUTES.OWNER.TRAINING_MAT_EXERCISE;
  }
  return null;
};

export const getSetupRouteForType = (type) => {
  switch (type) {
    case DEPARTURE_EXERCISE:
      return NAV_ROUTES.OWNER.TRAINING_SETUP;
    case DIAB_EXERCISE:
      return NAV_ROUTES.OWNER.TRAINING_DIAB_SETUP;
    case CRATE_EXERCISE:
      return NAV_ROUTES.OWNER.TRAINING_CRATE_SETUP;
    case MAT_EXERCISE:
      return NAV_ROUTES.OWNER.TRAINING_MAT_SETUP;
  }
  return null;
};

export const getEndRouteForType = (type) => {
  switch (type) {
    case DEPARTURE_EXERCISE:
      return NAV_ROUTES.OWNER.TRAINING_END;
    case DIAB_EXERCISE:
      return NAV_ROUTES.OWNER.TRAINING_DIAB_END;
    case CRATE_EXERCISE:
      return NAV_ROUTES.OWNER.TRAINING_CRATE_END;
    case MAT_EXERCISE:
      return NAV_ROUTES.OWNER.TRAINING_MAT_END;
  }
  return null;
};

export const getHistoryRouteForType = (type) => {
  switch (type) {
    case DEPARTURE_EXERCISE:
      return NAV_ROUTES.OWNER.HISTORY_EDIT;
    case DIAB_EXERCISE:
      return NAV_ROUTES.OWNER.HISTORY_DIAB_EDIT;
    case CRATE_EXERCISE:
      return NAV_ROUTES.OWNER.HISTORY_CRATE_EDIT;
    case MAT_EXERCISE:
      return NAV_ROUTES.OWNER.HISTORY_MAT_EDIT;
  }
  return null;
};

const getClientHistoryRouteTemplate = (type) => {
  switch (type) {
    case DEPARTURE_EXERCISE:
      return NAV_ROUTES.COACH.HISTORY_VIEW;
    case DIAB_EXERCISE:
      return NAV_ROUTES.COACH.HISTORY_DIAB;
    case CRATE_EXERCISE:
      return NAV_ROUTES.COACH.HISTORY_CRATE;
    case MAT_EXERCISE:
      return NAV_ROUTES.COACH.HISTORY_MAT;
  }
  return null;
};

export const getClientHistoryRouteForType = (familyId, type) => {
  const routeTemplate = getClientHistoryRouteTemplate(type);
  return routeTemplate.replace(':family_id', familyId).replace('/:exercise_id', '');
};

export const getClientHistoryDetailRouteForType = (familyId, exerciseId, type) => {
  const routeTemplate = getClientHistoryRouteTemplate(type);
  return routeTemplate.replace(':family_id', familyId).replace(':exercise_id', exerciseId);
};

export const getRouteToClient = (key, familyId) =>
  NAV_ROUTES.COACH[key].replace(":family_id", familyId);

export default NAV_ROUTES;
